<template>
  <div class="card mt-4 mt-md-2 table-container" v-if="posts.length > 0">
    <div class="card-header border-0 pl-2 pt-2">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">News Feed</h3>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table :data="posts" @onRowClicked="onRowClicked" :clickableRow="true">
        <template slot="columns">
          <th>Content</th>
          <th>Profile</th>
          <th>Name</th>
          <th>Views</th>
          <th>Like</th>
          <th>Comment</th>
          <th>Share</th>
          <th>Created Date</th>
        </template>

        <template slot-scope="{row}">
          <td class="text-truncate" style="max-width: 250px">{{ row.content }}</td>
          <td class="td-profile">
            <span class="avatar avatar-sm rounded-circle">
              <img
                :src="row.createdBy.profile ? row.createdBy.profile : require('@/assets/default_profile_picture.png')"
              />
            </span>
          </td>
          <td>{{row.createdBy.name}}</td>
          <td>{{row.views}}</td>
          <td>{{row.likesCount}}</td>
          <td>{{row.commentsCount}}</td>
          <td>{{row.sharesCount}}</td>
          <td>{{formatDate(row.createdDate)}}</td>
        </template>
      </base-table>
      <div class="card-footer d-flex justify-content-center">
        <base-pagination :page-count="totalPage" v-model="currentPage" @input="onPageChanged"></base-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

import { GET_POSTS } from '@/store/actions.type'

import moment from 'moment'

export default {
  name: 'news-feed-table',
  data() {
    return {
      currentPage: 1
    }
  },
  created() {
    this.$store.dispatch(GET_POSTS, this.currentPage)
  },
  methods: {
    onPageChanged(page) {
      this.$store.dispatch(GET_POSTS, page)
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY hh:mm A')
    },
    onRowClicked(index) {
      const post = this.posts[index]
      this.$router.push({ path: `/newsfeed/${post.id}` })
    }
  },
  computed: {
    ...mapState({
      posts: state => state.newsfeed.posts,
      totalPage: state => state.newsfeed.totalPage
    })
  }
}
</script>
